import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { cn } from "@utils";
import { XMarkIcon } from "@heroicons/react/24/outline";
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  maxDesktopWidth = "lg",
}) {
  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-black/40 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto sm:px-10">
        <div className="flex h-full items-end justify-center p-0 lg:p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className={cn(
              `relative overflow-auto transform flex flex-col rounded-t-3xl sm:rounded-3xl bg-white max-h-[80%] text-left shadow-xl transition-all data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 w-full`,
              `data-[closed]:translate-y-full data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 data-[closed]:sm:opacity-0`,
              {
                "sm:max-w-lg": maxDesktopWidth === "lg",
                "sm:max-w-2xl": maxDesktopWidth === "2xl",
              }
            )}
          >
            <div className="flex shrink-0 items-start border-b border-zinc-200 p-5 overflow-auto">
              <DialogTitle
                as="h3"
                className="text-base font-semibold text-zinc-900"
              >
                {title}
              </DialogTitle>
              <button
                type="button"
                onClick={onClose}
                className="ml-auto rounded-md bg-white text-zinc-400 hover:text-zinc-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 cursor-pointer"
              >
                <span className="sr-only">Close</span>
                <XMarkIcon aria-hidden="true" className="size-6" />
              </button>
            </div>
            {children}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
